import gql from "graphql-tag";

export const PROPERTY = gql`
  query property($id: ID!) {
    property(id: $id) {
      propertyInformation {
        type
        entities {
          id
          title
          value
        }
      }
      photos {
        image
        preview2x
        id
      }
      mainInfo {
        id
        city
        street
        listPrice
        coordinates
        overview
        bedrooms
        bathrooms
        bathsFull
        viewsNumber
        onMarket
        likelihoodToSell
        likelihoodToSellDescription
        isInteresting
        interestingPropertiesCount
        canEdit
        source
        insights
        status
        listingId
        listOfficeName
        modificationDate
        fullAddress
        livingArea
        virtualTourUrl
        anycurbLastChecked
        wsWalk {
          score
          description
        }
        wsTransit {
          score
          description
        }
        wsBike {
          score
          description
        }
      }

      priceHistory {
        date
        event
        price
      }
      schools {
        title
        schoolLevel
        type
        grades
        distance
        rating
      }
      features {
        features {
          title
          icon
          values
        }
        # score
      }
      haveActivePropertyBanner
      haveClaimedPropertyUpdates
    }
  }
`;

export const SIMILAR_PROPERTIES = gql`
  query getSimilarProperties($propertyId: Int!, $limit: Int) {
    similarProperties(propertyId: $propertyId, limit: $limit) {
      id
      score
      listPrice
      bathsFull
      city
      street
      onMarket
      isInteresting
      status
      fullAddress
      daysOnMarket
      livingArea
      likelihoodToSellDescription
      photos {
        id
        image
        preview2x
      }
    }
  }
`;

export const MARKET_INFO = gql`
  query marketInfo($propertyId: Int!) {
    marketInfo(propertyId: $propertyId) {
      totalHomes
      superLikely
      extremelyLikely
      likely
    }
  }
`;

export const CLAIMED_PROPERTY_EDIT_FORM = gql`
  query claimedPropertyEditForm($propertyId: ID!) {
    claimedPropertyEditForm(propertyId: $propertyId) {
      data {
        name
        inputs {
          name
          type
          label
          value
        }
      }
      photos {
        id
        image
        preview2x
      }
    }
  }
`;

export const UPDATE_CLAIMED_HOME = gql`
  mutation updateClaimedProperty($id: ID!, $propertyParams: PropertyArgument!) {
    updateClaimedProperty(id: $id, propertyParams: $propertyParams) {
      property {
        id
        bedrooms
      }
    }
  }
`;

export const ADD_TO_INTERESTING = gql`
  mutation createInterestingProperty($propertyId: ID!) {
    createInterestingProperty(propertyId: $propertyId) {
      status
    }
  }
`;
